<div class="modal-body width-500">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">
      {{getRessource('Title')}}
    </h5>
    <div class="content">
      <div>
        <exg-input [(ngModel)]="uiModel.contactDateTime"
                   name="contactDateTime"
                   type="datetime-local"
                   [step]="60"
                   [caption]="getRessource('DateTime')">
        </exg-input>
      </div>
      <div>
        <exg-textarea [(ngModel)]="uiModel.comment"
                      name="comment"
                      [caption]="getRessource('Comment')">
        </exg-textarea>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="cancel()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="save()" class="md-btn">
        {{getGlobal('Confirm')}}
      </button>
    </div>
  </div>
</div>
